








































































import {Component, PropSync} from 'vue-property-decorator'
import {Getter, Action} from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import {AccountFilter} from "@/store/accounts/types";
import {SelectWings, ToggleWings} from "@/components";
import {notifyError} from "@/utils/notify-helper";

@Component({components: {SelectWings, ToggleWings}})
export default class AccountsFilter extends BaseFilter<AccountFilter>{
  @PropSync('show') is_show!: boolean;
  @Getter("transports") transportsList: any;
  @Getter("protocolList") protocolList: any;
  @Action("getTransports") actionGetTransports: any;
  @Action("getAccounts") actionGetAccounts: any;
  @Action("exportAccounts") actionExportAccounts: any;

  statusList: number[] = [1,0];

  defaultFilter(): AccountFilter {
    return {
      login: undefined,
      protocol: undefined,
      transport: undefined,
      status: undefined,
    }
  }

  created() {
    this.actionGetTransports();
    this.filtered();
  }

  onFilteredAction(): void {
    this.actionGetAccounts(this.filter);
  }

  export():void {
    try {
      this.actionExportAccounts(this.filter)
    } catch(error) {
      notifyError(error)
    }
  }
}
